import { api } from '@/lib/axios';

export interface BrandingConfig {
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  backgroundColor: string;
  surfaceColor: string;
  textColor: string;
  logoUrl?: string;
  faviconUrl?: string;
  loginBgUrl?: string;
  appName: string;
  companyName?: string;
}

// Default Caruso colors
export const defaultBranding: BrandingConfig = {
  primaryColor: '#C8A15A',    // brand-gold
  secondaryColor: '#5A3E2B',  // brand-cigar
  accentColor: '#F4F1E9',     // brand-ivory
  backgroundColor: '#0E0E0F', // brand-ink
  surfaceColor: '#1A1A1A',    // brand-smoke
  textColor: '#F4F1E9',       // brand-ivory
  appName: 'Caruso CRM',
};

export const brandingService = {
  async get(): Promise<BrandingConfig> {
    try {
      const response = await api.get<BrandingConfig>('/settings/branding');
      return response.data;
    } catch {
      return defaultBranding;
    }
  },

  async getPublic(): Promise<BrandingConfig> {
    try {
      const response = await api.get<BrandingConfig>('/settings/branding/public');
      return response.data;
    } catch {
      return defaultBranding;
    }
  },

  async update(data: Partial<BrandingConfig>): Promise<BrandingConfig> {
    const response = await api.put<BrandingConfig>('/settings/branding', data);
    return response.data;
  },
};
